import BackendService from './BackendService';

async function getShift(id) {
  return BackendService.getData(`/shifts/${id}/`);
}
async function getShifts(params) {
  return BackendService.getData('/shifts/', {}, params);
}
async function getShiftTransactions(id) {
  const ledgerData = await BackendService.getData('/account-ledger/', {}, { shift_id: id, limit: 5000 });
  return ledgerData.results || ledgerData || [];
}
async function getShiftDetails(id) {
  return BackendService.getData(`/shifts/${id}/`);
}

async function closeShift(id, data = {}) {
  return BackendService.postData(`/shifts/${id}/close/`, data);
}

const ShiftService = {
  getShift,
  getShifts,
  getShiftTransactions,
  getShiftDetails,
  closeShift,
};

export default ShiftService;
